var map = {
	"./stain-01.png": 7823,
	"./stain-02.png": 9734,
	"./stain-03.png": 4036,
	"./stain-04.png": 6234,
	"./stain-05.png": 1959,
	"./stain-06.png": 5563,
	"./stain-07.png": 9155,
	"./stain-08.png": 7537,
	"./stain-09.png": 2269,
	"./stain-10.png": 1314,
	"./stain-11.png": 1679,
	"./stain-12.png": 9634,
	"./stain-13.png": 2352,
	"./stain-14.png": 8793,
	"./stain-15.png": 3437,
	"./stain-16.png": 8640,
	"./stain-17.png": 3718,
	"./stain-18.png": 1129,
	"./stain-19.png": 1764,
	"./stain-20.png": 9825,
	"./stain-21.png": 1613,
	"./stain-22.png": 6988,
	"./stain-23.png": 1930,
	"./stain-24.png": 9890,
	"./stain-25.png": 1573,
	"./stain-26.png": 7213,
	"./stain-27.png": 4656,
	"./stain-28.png": 13,
	"./stain-29.png": 5540,
	"./stain-30.png": 64,
	"./stain-31.png": 1724,
	"./stain-32.png": 3234,
	"./stain-33.png": 4446,
	"./stain-34.png": 209,
	"./stain-35.png": 2564,
	"./stain-36.png": 5835,
	"./stain-37.png": 1369,
	"./stain-38.png": 5918,
	"./stain-39.png": 1594,
	"./stain-40.png": 2756,
	"./stain-41.png": 9474,
	"./stain-42.png": 8194,
	"./stain-43.png": 7277,
	"./stain-44.png": 8006,
	"./stain-45.png": 7915,
	"./stain-46.png": 3705,
	"./stain-47.png": 3646,
	"./stain-48.png": 5388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3863;